import AxiosInstance from './config/Http'
import Config from './config/Constants'
import { fetchAllPages } from './config/Pagination'

export const getMaintenancesByUnitId = async (unitId: string, type: any) => {
  const strType = type.join('&type.in=')
  return fetchAllPages<any>(`${Config.core.maintenances}`, {
    sort: 'id,desc',
    'unitId.equals': unitId,
    'type.in': strType,
  })
}

export const getMaintenance = async (id: string) => {
  return AxiosInstance.get(
    `${Config.core.maintenances}/${id}`
  )
}
